import React from 'react';
import { InputNumber } from 'antd';
import { InputNumberProps } from 'antd/lib/input-number';
import { isNil } from 'lodash';

export type InputMoneyProps = InputNumberProps;

const InputRate = (props: InputMoneyProps) => {
  return (
    <InputNumber
      precision={5}
      formatter={(value) =>`${(!isNil(value)&&value!=="")?Number.parseFloat(String(value)).toFixed(5):0}%`}
      parser={(value) => (value ? value.replace('%', '') : '')}
      min={props.min}
      {...props}
    />
  );
};

export default InputRate;
